module.exports = __webpack_public_path__ + "static/media/bs.eac24640.svg";